import { getSessionStore } from '@/config/mUtils';
import { baseUrl, switchUnite } from '@/config/env';

export function getImport(url) {
  let url_type = window.location.host,
    token = getSessionStore('token');

  if (url_type){
    let ip = url_type.split(':')[0];

    if('http://172.20.28.50:81'.indexOf(ip) !=-1){
      url = 'http://172.20.28.50:81' + url;
    } else{
      url = baseUrl + url;
    }
    return url+'?access_token='+token;
  } return;
}

export function getImportUrl(url) {
  let urli = '';

  if(switchUnite) {
    urli = `/platform${url}`;
  } else {
    urli = `/exportOrDown${url}`;
  }
  return `${baseUrl}${urli}?access_token=${getSessionStore('token')}`;
  // let url_type = window.location.host,
  //   token = getSessionStore('token');

  // if (url_type){
  //   let ip = url_type.split(':')[0];

  //   if('http://172.20.28.50:81'.indexOf(ip) !=-1){
  //     urli = 'http://172.20.28.50:81' + urli;
  //   } else{
  //     urli = baseUrl + urli;
  //   }
  //   return urli+'?access_token='+token;
  // } return;
}